import { lazy, Suspense } from 'react';
import { BrowserRouter, Redirect, Switch } from 'react-router-dom';
import Route, { RouteProps, RouteAccess } from './Route';
import { MainLayout, BlogLayout, WorkLayout, PressLayout, SplashLayout, AuditSplashLayout, AuditASplashLayout, FootprintSplashLayout, EmrSplashLayout, EstateSplashLayout, Estate1SplashLayout, ExposureReportSplashLayout, ExposureLandingSplashLayout, FixmeSplashLayout, LandingLayout } from 'view/components/layout';
import { LoadingSpinner } from 'view/components/common/LoadingSpinner';
const BlogPage = lazy(() => import('view/pages/Blog'));
const PressPage = lazy(() => import('view/pages/Press'));
const TeamPage = lazy(() => import('view/pages/Team'));
const LabPage = lazy(() => import('view/pages/Lab'));
const BlogPostPage = lazy(() => import('view/pages/BlogPost'));
const WorkPage = lazy(() => import('view/pages/Work'));
// const CaseStudyPage = lazy(() => import('view/pages/CaseStudy'));
const NewCaseStudyPage = lazy(() => import('view/pages/NewCaseStudy/NewCaseStudy'));
const PasswordPage = lazy(() => import('view/pages/Password'));
const ColorContrastCheckerPage = lazy(() => import('view/pages/ColorContrastChecker'));
const NotFoundPage = lazy(() => import('view/pages/NotFound'));
const QRCodeGeneratorPage = lazy(() => import('view/pages/QRCode/QRCode'));
const RipplingCareersPage = lazy(() => import('view/pages/RipplingCareers'));
const JobDescriptionPage = lazy(() => import('view/pages/JobDescription/JobDescription'));
const SuccessPage = lazy(() => import('view/pages/Careers/Success'));
const CheckoutPage = lazy(() => import('view/pages/Checkout'));
const PrivacyPage = lazy(() => import('view/pages/Privacy'));
const TermsPage = lazy(() => import('view/pages/Terms'));
const ExposureAssessmentPage = lazy(() => import('view/pages/ExposureAssessment/ExposureAssessment'));
const IporGptPage = lazy(() => import('view/pages/IporGpt/IporGpt'));
const CompliancePipedaPage = lazy(() => import('view/pages/CompliancePipeda/CompliancePipeda'));
const AppAuditPage = lazy(() => import('view/pages/AppAudit'));
const AboutPage = lazy(() => import('view/pages/About'));
const ThankYouPage = lazy(() => import('view/pages/ThankYou'));
const ContactUsPage = lazy(() => import('view/pages/ContactUs'));
const WebinarPage = lazy(() => import('view/pages/Webinar'));
const WebinarCourseDetailPage = lazy(() => import('view/pages/Webinar/CourseDetail'));
const MarketingIndexPage = lazy(() => import('view/pages/Marketing'));
const PatentTechWithoutStallingGrowthPage = lazy(() => import('view/pages/LandingPages/Webinars/PatentTechWithoutStallingGrowth'));
const IpGrowthStrategyPage = lazy(() => import('view/pages/LandingPages/Webinars/IpGrowthStrategy'));
const PatentsAsStrategyPage = lazy(() => import('view/pages/LandingPages/Webinars/PatentsAsStrategy'));
const IpProtectionFoundersGuidePage = lazy(() => import('view/pages/LandingPages/Guides/IpProtectionFounders'));
const AiIndustry2026ReportPage = lazy(() => import('view/pages/LandingPages/Reports/AiIndustry2026'));
const AiIndustry2026GuideViewerPage = lazy(() => import('view/pages/LandingPages/Reports/AiIndustry2026GuideViewer'));
const AiEnterprisePlaybookReportPage = lazy(() => import('view/pages/LandingPages/Reports/AiEnterprisePlaybook'));
const AiEnterprisePlaybookGuideViewerPage = lazy(() => import('view/pages/LandingPages/Reports/AiEnterprisePlaybookGuideViewer'));
const BuildAiAgentShipPage = lazy(() => import('view/pages/LandingPages/Webinars/BuildAiAgentShip'));
const BuildFirstAIAgent7DaysPage = lazy(() => import('view/pages/LandingPages/Webinars/BuildFirstAIAgent7Days'));
const BuildProductWithAIPage = lazy(() => import('view/pages/LandingPages/Webinars/BuildProductWithAI'));
const BuildYourFirstAIAgentPage = lazy(() => import('view/pages/LandingPages/Webinars/BuildYourFirstAIAgent'));
const ServiceCategoryPage = lazy(() => import('view/pages/ServiceCategory/ServiceCategoryPage'));

export enum RoutePath {
    NEW_CASE_STUDY = '/work/:id',
    WORK = '/work',
    TEAM = '/team',
    ABOUT = '/about',
    LAB = '/lab',
    BLOG_POST = '/blog/:id',
    BLOG = '/blog',
    PRESS = '/press',
    PASSWORD = '/password-generator',
    COLOR_CONTRAST_CHECKER = '/color-contrast-checker',
    ROOT = '/',
    NOT_FOUND = '/page-not-found',
    QR_CODE = '/qr-code-generator',
    CAREERS = '/careers',
    JobApplication = '/apply/:id',
    CHECKOUT ='/checkout',
    PRIVACY = '/privacy',
    TERMS = '/terms',
    AUDIT = '/audit',
    AUDIT_A = '/audit-a',
    FOOTPRINT = '/footprint',
    EMR = '/emr',
    ESTATE = '/estate',
    ESTATE_1 = '/estate-1',
    EXPOSURE_REPORT = '/exposure-report',
    EXPOSURE_ASSESSMENT = '/exposure-assessment',
    CONTACT = '/contact',
    FIXME = '/fixme',
    IPORGPT = '/ip-or-gpt',
    COMPLIANCE_PIPEDA = '/compliance-pipeda',
    APP_AUDIT = '/app-audit',
    THANK_YOU = '/thank-you',
    CONTACT_US = '/contact-us',
    MARKETING = '/marketing',
    WEBINAR = '/webinar',
    WEBINAR_COURSE = '/webinar/:courseSlug',
    WEBINAR_PATENT_TECH_WITHOUT_STALLING_GROWTH = '/webinars/patent-tech-without-stalling-growth',
    WEBINAR_IP_GROWTH_STRATEGY = '/webinars/ip-growth-strategy',
    WEBINAR_PATENTS_AS_STRATEGY = '/webinars/patents-as-strategy',
    GUIDE_IP_PROTECTION_FOUNDERS = '/guides/ip-protection-founders',
    REPORT_AI_INDUSTRY_2026 = '/reports/ai-industry-2026',
    REPORT_AI_INDUSTRY_2026_GUIDE = '/reports/ai-industry-2026/guide',
    REPORT_AI_ENTERPRISE_PLAYBOOK = '/reports/ai-enterprise-playbook',
    REPORT_AI_ENTERPRISE_PLAYBOOK_GUIDE = '/reports/ai-enterprise-playbook/guide',
    WEBINAR_BUILD_AI_AGENT_SHIP = '/webinars/build-ai-agent-ship',
    WEBINAR_BUILD_FIRST_AI_AGENT_7_DAYS = '/webinars/build-first-ai-agent-7-days',
    WEBINAR_BUILD_PRODUCT_WITH_AI = '/webinars/build-product-with-ai',
    WEBINAR_BUILD_YOUR_FIRST_AI_AGENT = '/webinars/build-your-first-ai-agent',
    SERVICE_CATEGORY = '/services/:slug',
}

const routes: Array<RouteProps> = [
    {
        path: RoutePath.COLOR_CONTRAST_CHECKER,
        access: RouteAccess.public,
        layout: MainLayout,
        component: ColorContrastCheckerPage,
    },

    {
        path: RoutePath.PASSWORD,
        access: RouteAccess.public,
        layout: MainLayout,
        component: PasswordPage,
    },

    {
        path: RoutePath.NEW_CASE_STUDY,
        access: RouteAccess.public,
        layout: MainLayout,
        component: NewCaseStudyPage,
    },

    {
        path: RoutePath.WORK,
        access: RouteAccess.public,
        layout: WorkLayout,
        component: WorkPage
    },

    {
        path: RoutePath.TEAM,
        access: RouteAccess.public,
        layout: MainLayout,
        component: TeamPage
    },

    {
        path: RoutePath.ABOUT,
        access: RouteAccess.public,
        layout: MainLayout,
        component: AboutPage
    },

    {
        path: RoutePath.THANK_YOU,
        access: RouteAccess.public,
        layout: MainLayout,
        component: ThankYouPage
    },

    {
        path: RoutePath.CONTACT_US,
        access: RouteAccess.public,
        layout: MainLayout,
        component: ContactUsPage
    },

    {
        path: RoutePath.MARKETING,
        access: RouteAccess.public,
        layout: LandingLayout,
        component: MarketingIndexPage,
    },

    {
        path: RoutePath.WEBINAR_COURSE,
        access: RouteAccess.public,
        layout: MainLayout,
        component: WebinarCourseDetailPage
    },

    {
        path: RoutePath.WEBINAR,
        access: RouteAccess.public,
        layout: MainLayout,
        component: WebinarPage
    },

    /* Landing pages */
    {
        path: RoutePath.WEBINAR_PATENT_TECH_WITHOUT_STALLING_GROWTH,
        access: RouteAccess.public,
        layout: LandingLayout,
        component: PatentTechWithoutStallingGrowthPage,
    },
    {
        path: RoutePath.WEBINAR_IP_GROWTH_STRATEGY,
        access: RouteAccess.public,
        layout: LandingLayout,
        component: IpGrowthStrategyPage,
    },
    {
        path: RoutePath.WEBINAR_PATENTS_AS_STRATEGY,
        access: RouteAccess.public,
        layout: LandingLayout,
        component: PatentsAsStrategyPage,
    },
    {
        path: RoutePath.GUIDE_IP_PROTECTION_FOUNDERS,
        access: RouteAccess.public,
        layout: LandingLayout,
        component: IpProtectionFoundersGuidePage,
    },
    {
        path: RoutePath.REPORT_AI_INDUSTRY_2026,
        access: RouteAccess.public,
        layout: LandingLayout,
        component: AiIndustry2026ReportPage,
    },
    {
        path: RoutePath.REPORT_AI_INDUSTRY_2026_GUIDE,
        access: RouteAccess.public,
        layout: LandingLayout,
        component: AiIndustry2026GuideViewerPage,
    },
    {
        path: RoutePath.REPORT_AI_ENTERPRISE_PLAYBOOK,
        access: RouteAccess.public,
        layout: LandingLayout,
        component: AiEnterprisePlaybookReportPage,
    },
    {
        path: RoutePath.REPORT_AI_ENTERPRISE_PLAYBOOK_GUIDE,
        access: RouteAccess.public,
        layout: LandingLayout,
        component: AiEnterprisePlaybookGuideViewerPage,
    },
    {
        path: RoutePath.WEBINAR_BUILD_AI_AGENT_SHIP,
        access: RouteAccess.public,
        layout: LandingLayout,
        component: BuildAiAgentShipPage,
    },
    {
        path: RoutePath.WEBINAR_BUILD_FIRST_AI_AGENT_7_DAYS,
        access: RouteAccess.public,
        layout: LandingLayout,
        component: BuildFirstAIAgent7DaysPage,
    },
    {
        path: RoutePath.WEBINAR_BUILD_PRODUCT_WITH_AI,
        access: RouteAccess.public,
        layout: LandingLayout,
        component: BuildProductWithAIPage,
    },
    {
        path: RoutePath.WEBINAR_BUILD_YOUR_FIRST_AI_AGENT,
        access: RouteAccess.public,
        layout: LandingLayout,
        component: BuildYourFirstAIAgentPage,
    },

    {
        path: RoutePath.SERVICE_CATEGORY,
        access: RouteAccess.public,
        layout: MainLayout,
        component: ServiceCategoryPage,
    },

    {
        path: RoutePath.LAB,
        access: RouteAccess.public,
        layout: MainLayout,
        component: LabPage
    },

    {
        path: RoutePath.BLOG_POST,
        access: RouteAccess.public,
        layout: MainLayout,
        component: BlogPostPage
    },

    {
        path: RoutePath.BLOG,
        access: RouteAccess.public,
        layout: BlogLayout,
        component: BlogPage
    },

    {
        path: RoutePath.PRESS,
        access: RouteAccess.public,
        layout: PressLayout,
        component: PressPage
    },

    {
        path: RoutePath.ROOT,
        access: RouteAccess.public,
        layout: SplashLayout
    },

    {
        path: RoutePath.AUDIT,
        access: RouteAccess.public,
        layout: AuditSplashLayout
    },

    {
        path: RoutePath.AUDIT_A,
        access: RouteAccess.public,
        layout: AuditASplashLayout
    },

    {
        path: RoutePath.FOOTPRINT,
        access: RouteAccess.public,
        layout: FootprintSplashLayout
    },

    {
        path: RoutePath.EMR,
        access: RouteAccess.public,
        layout: EmrSplashLayout
    },

    {
        path: RoutePath.ESTATE,
        access: RouteAccess.public,
        layout: EstateSplashLayout
    },

    {
        path: RoutePath.ESTATE_1,
        access: RouteAccess.public,
        layout: Estate1SplashLayout
    },

    {
        path: RoutePath.EXPOSURE_REPORT,
        access: RouteAccess.public,
        layout: ExposureReportSplashLayout
    },

    {
        path: RoutePath.EXPOSURE_ASSESSMENT,
        access: RouteAccess.public,
        layout: MainLayout,
        component: ExposureAssessmentPage
    },

    {
        path: RoutePath.CONTACT,
        access: RouteAccess.public,
        layout: ExposureLandingSplashLayout
    },

    {
        path: RoutePath.FIXME,
        access: RouteAccess.public,
        layout: FixmeSplashLayout
    },

    {
        path: RoutePath.IPORGPT,
        access: RouteAccess.public,
        layout: MainLayout,
        component: IporGptPage
    },

    {
        path: RoutePath.COMPLIANCE_PIPEDA,
        access: RouteAccess.public,
        layout: MainLayout,
        component: CompliancePipedaPage
    },

    {
        path: RoutePath.APP_AUDIT,
        access: RouteAccess.public,
        layout: MainLayout,
        component: AppAuditPage
    },

    {
        path: RoutePath.NOT_FOUND,
        access: RouteAccess.public,
        layout: MainLayout,
        component: NotFoundPage
    },
    {
        path: RoutePath.QR_CODE,
        access: RouteAccess.public,
        layout: MainLayout,
        component: QRCodeGeneratorPage
    },
    {
        path: RoutePath.CAREERS,
        access: RouteAccess.public,
        layout: MainLayout,
        component: RipplingCareersPage
    },
    {
        path: RoutePath.JobApplication,
        access: RouteAccess.public,
        layout: MainLayout,
        component: JobDescriptionPage
    },
    {
        path: '/careers/success',
        access: RouteAccess.public,
        layout: MainLayout,
        component: SuccessPage
    },
    {
        path: RoutePath.CHECKOUT,
        access: RouteAccess.public,
        layout: MainLayout,
        component: CheckoutPage
    },
    {
        path: RoutePath.PRIVACY,
        access: RouteAccess.public,
        layout: MainLayout,
        component: PrivacyPage
    },
    {
        path: RoutePath.TERMS,
        access: RouteAccess.public,
        layout: MainLayout,
        component: TermsPage
    }
];

const AppRouter: React.FunctionComponent = () =>
{
    return (
        <Suspense fallback={LoadingSpinner({})}>
            <BrowserRouter>
                <Switch>
                    <Redirect exact from="/landing" to="/contact" />
                    <Redirect exact from="/compliancepipeda" to="/compliance-pipeda" />
                    <Redirect exact from="/iporgpt" to="/ip-or-gpt" />
                    <Redirect exact from="/blog/flatten-the-curve" to="/blog/growing-technologies-covid" />
                    <Redirect exact from="/blog/designing-for-all" to="/blog/wcag-guidelines" />
                    <Redirect exact from="/blog/future-of-tech" to="/blog/growing-technologies-covid" />
                    <Redirect exact from="/blog/6-steps-to-successful-email-networking" to="/blog" />
                    <Redirect exact from="/blog/change-the-world" to="/blog" />
                    <Redirect exact from="/blog/remote-learning" to="/blog" />
                    <Redirect exact from="/blog/how-one-app-has-created-transparency-on-campus" to="/work/podd" />
                    <Redirect exact from="/blog/remote-or-home" to="/blog/going-remote" />
                    <Redirect exact from="/blog/growing-tech-covid" to="/blog/growing-technologies-covid" />
                    <Redirect exact from="/blog/1" to="/blog/future-of-tech" />
                    <Redirect exact from="/blog/4" to="/blog/break-into-tech" />
                    <Redirect exact from="/blog/5" to="/blog/why-startups" />
                    {
                        routes.map(({ path, access, component, ...props }: RouteProps) =>
                        {
                            return (
                                <Route
                                    key={path}
                                    exact={true}
                                    path={path}
                                    access={access}
                                    component={component}
                                    {...props}
                                />
                            );
                        })
                    }
                    <Redirect from={'*'} to={RoutePath.NOT_FOUND} />
                    <Route exact={false} path={'*'} component={NotFoundPage} access={RouteAccess.public} />
                </Switch>
            </BrowserRouter>
        </Suspense>
    );
};

export default AppRouter;
